import { z } from 'zod';
import { type Tasks } from '../../../workflow/schemaTypes';

export type ResolutionData = Record<
  Extract<Tasks, 'resolution'>,
  {
    resolutionId?: string;
    exchangeItem?: {
      productId: string;
      variantId: string;
    };
  }
>;

export const ResolutionTaskSchema = z.object({
  resolutionId: z
    .string({
      error: (issue) =>
        issue.input === undefined ? 'Selection required' : 'Selection required',
    })
    .min(1),
  exchangeItem: z
    .object({
      productId: z.string().min(1),
      variantId: z.string().min(1),
    })
    .optional(),
});
